<template>
  <div class="webinar-single">
    <div class="show-diff" v-if="!isWebinar">
      <span @click="handleShowDifferent" @keydown.enter="handleShowDifferent" role="button" tabindex="0" aria-label="how are they different">{{ _$t('howAreTheyDifferent') }}</span>
    </div>
    <div :class="['webinar-single_container', {
      'webinar-single_container-mobile': isWebinar && hideDesc
    }]">
      <div v-for="(col, index) in tableColumn" :key="col.label" :class="['webinar-single_container-item', {
        webinar: isWebinar
      }]" >
        <span 
          :class="['label-value', {
                blue: index > (isWebinar && hideDesc ? -1 : 0)
              }]" 
          @click="handleChooseCycle(col)"
          :tabindex="index > (isWebinar && hideDesc ? -1 : 0) ? '0' : '-1'"
          :aria-label="`select ${col.label}`"
        >{{ col.label }}</span>
        <span class="value">{{ col.value }}</span>
      </div>
    </div>
    <div :class="{
      'contact-sales-container': !isWebinar
    }">
      <div :class="['contact-sales', {
        'webinar': isWebinar,
        'webinar-mobile': isWebinar && hideDesc
      }]">
      <span class="contact-sales_tip">{{ contactSalesTip }} <span class="contact-sales_btn" @keydown.enter="handleContactSales" @click="handleContactSales" role="button" tabindex="0" aria-label="contact sales">{{ _$t('fbc.common.button.contact_sales') }}</span></span>
      </div>
      <div :class="['contact-sales contact-sales__more']" v-if="contactSalesMoreTip">
        <span class="contact-sales_tip_more">{{ contactSalesMoreTip }} <span class="contact-sales_btn" @keydown.enter="handleContactSales"  @click="handleContactSales"  role="button" tabindex="0" aria-label="contact sales">{{ _$t('fbc.common.button.contact_sales') }}</span></span>
      </div>
    </div>
    <div class="attedees_desc">
      <label>{{ attedeesDescLabel }}</label>
      <span> {{ attedeesDescContent }}</span>
    </div>
  </div>
</template>

<script>
import { t } from '@/plugins/i18n';

export default {
  name: 'SingleWebinarTip',
  props: {
    planType: {
      type: String,
      default: 'webinar',
    },
    contacsSalesLink: String,
    hideDesc: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _$t () {
      return t;
    },
    isWebinar() {
      return this.planType === 'webinar';
    },
    contactSalesTip () {
      if (this.isWebinar) return '10,000+';
      return '3,000+';
    },
    contactSalesMoreTip () {
      if (this.isWebinar) return '';
      return '10,000+';
    },
    tableColumn() {
      return [
        {
          label: 'Plan',
          value: this._$t('fbc.add_ons.webinar.attendees'),
          show: this.isWebinar && !this.hideDesc
        },
        {
          label: 'Plan',
          value: 'Attendees',
          show: !this.isWebinar
        },
        {
          label: this._$t('fbc.add_ons.webinar.monthly_subscription'),
          value: '500-10,000',
          show: this.isWebinar,
          cycle: 'monthly'
        },
        {
          label: this._$t('fbc.add_ons.webinar.monthly_subscription'),
          value: '100',
          show: !this.isWebinar,
           cycle: 'monthly'
        },
        {
          label: this._$t('fbc.add_ons.webinar.annual_subscription'),
          value: '500-5,000',
          show: this.isWebinar,
          cycle: 'annual'
        },
        {
          label: this._$t('fbc.add_ons.webinar.annual_subscription'),
          value: '100-3,000',
          show: !this.isWebinar,
          cycle: 'annual'
        },
        {
          label: this._$t('fbc.add_ons.webinar.one_month'),
          value: '500-10,000',
          show: this.isWebinar,
          cycle: 'one_month'
        },
        {
          label: this._$t('fbc.add_ons.webinar.single_use'),
          value: '20,000-' + this._$t('fbc.add_ons.webinar.one_million'),
          show: this.isWebinar,
          cycle: 'one_time'
        },
        {
          label: this._$t('fbc.add_ons.webinar.pay_per_attendee'),
          value: '50-10,000',
          show: !this.isWebinar,
          cycle: 'ppa'
        },
      ].filter((c) => c.show);
    },
    attedeesDescLabel () {
      if (this.isWebinar) return this._$t('fbc.add_ons.webinar.webinar_attendee');
      return this._$t('fbc.add_ons.webinar.event_attendee')
    },
    attedeesDescContent () {
      if (this.isWebinar) return this._$t('fbc.add_ons.webinar.webinar_attendee_desc');
      return this._$t('fbc.add_ons.webinar.event_attendee_desc')
    }
  },
  methods: {
    handleShowDifferent () {
      this.$emit('showDifferent')
    },
    handleContactSales () {
      console.log(999)
      if (this.contacsSalesLink) {
        location.href = this.contacsSalesLink
      } else {
        this.$emit('contactSales')
      }
    },
    handleChooseCycle (config) {
      config.cycle && this.$emit('handleChooseCycle', config.cycle);
    }
  }
};
</script>

<style lang="scss">
.webinar-single {
  width: 100%;
  font-weight: 500;
  color: #00031F;
  font-size: 14px;


  &_container {
    display: flex;
    border: 1px solid #DDDDDD;
    border-right: none;

    &-item {
      display: flex;
      flex-direction: column;
      width: 25%;

      &.webinar {
        width: 20%;
      }

      span {
        font-size: 14px;
        padding: 20px 0;
        text-align: center;
        border-right: 1px solid #DDDDDD;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        word-break: break-word;
  
        &.label-value {
          height: 80px;
          background: #F7F7F8;
          color: #00031F;
          

          &.blue {
            color: #0B5CFF;
            cursor: pointer;
          }
        }
    
        &.value {
          padding: 0 6px;
          height: 58px;
          border-top: 1px solid #DDDDDD;
          
        }
      }
    }

    &-mobile {
      .webinar-single_container-item {
        width: 25%;
      }
    }
  }

  .show-diff {
    width: 75%;
    margin-left: 25%;
    height: 8px;
    border: 1px solid #ddd;
    border-bottom: none;
    margin-bottom: 8px;
    text-align: center;
    margin-top: 40px;
   
    span {
      color: #0B5CFF;
      cursor: pointer;
      position: relative;
      top: -25px;
    }
  }

  .contact-sales {
    width: 25%;
    margin-left: 50%;
    height: 8px;
    border: 1px solid #ddd;
    border-top: none;
    margin-top: 8px;
    text-align: center;
  
    &.webinar {
      width: 60%;
      margin-left: 20%;
    }

    &.webinar-mobile {
      width: 75%;
      margin-left: 0;
    }


    &_tip,
    &_tip_more {
      position: relative;
      top: 12px;
      line-height: .8;

      .contact-sales_btn {
        cursor: pointer;
        color: #0B5CFF;
      }
    }
  }


  .contact-sales-container {
      display: flex;
      align-items: flex-start;
      gap: 2%;
      padding-left: 50%;

      .contact-sales {
        width: 49%;
        margin-left: unset;

        &_btn {
          display: block;
        }
      }
  }

  .attedees_desc {
    margin-top: 30px;
    font-size: 12px;
    line-height: 15px;
    color: #666487;

    label {
      color: #00053D;
    }
  }

  .contact-sales-container + .attedees_desc {
    margin-top: 50px;
  }
}
</style>
